import React from 'react';

import Grid from '@mui/material/Grid';
import { styled, ThemeProvider } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';

import { imageURL } from '@src/services/api/images';

import theme from '@src/containers/theme';
import ImageChooser from '@src/custom/image_input/image_chooser';
import ImageUploader from '@src/custom/image_input/image_uploader';

const StyledContainer = styled(Grid)(({ theme }) => ({
    padding: typeof theme?.spacing === 'function' ? theme.spacing(2) : '16px',
}));

const StyledOr = styled(Typography)(({ theme }) => ({
    padding: typeof theme?.spacing === 'function' ? theme.spacing(2) : '16px',
    textAlign: 'center',
}));

/**
 * Images selector for CKEditor images selector.
 *
 * This component is used as root for /image-selectors path and loaded by
 * popup window from the CKEditor file browser.
 */
const ImageSelector = () => {
    const { search } = useLocation();

    const handleImageSelect = React.useCallback((image) => {
        const parsedSearch = queryString.parse(search) || {};
        const funcRef = parsedSearch.CKEditorFuncNum;

        if (funcRef) {
            window.opener.CKEDITOR.tools.callFunction(funcRef, imageURL(image));
        }

        window.close();
    }, [search]);

    const handleCancel = React.useCallback(() => {
        window.close();
    }, []);

    return (
        <ThemeProvider theme={theme}>
            <StyledContainer
                container
                justifyContent="center"
                alignItems="center"
            >
                <Grid size={12}>
                    <ImageUploader
                        folderName="content"
                        onCancel={handleCancel}
                        onImageUploaded={handleImageSelect}
                    />
                </Grid>
                <Grid size={12}>
                    <StyledOr variant="body1">
                        or choose existing
                    </StyledOr>
                </Grid>
                <Grid size={12}>
                    <ImageChooser
                        folderName="content"
                        showCopy={false}
                        onImageChoosed={handleImageSelect}
                    />
                </Grid>
            </StyledContainer>
        </ThemeProvider>
    );
};

export default ImageSelector;
